import React from 'react';

const Partners = () => {
  const partners = [
    {
      name: 'Esri',
      logo: '/partners/esri.png',
      alt: 'Esri - GIS Software'
    },
    {
      name: 'ArcGIS Online',
      logo: '/partners/arcgis-online.png',
      alt: 'ArcGIS Online'
    },
    {
      name: 'Mapbox',
      logo: '/partners/mapbox.png',
      alt: 'Mapbox'
    },
    {
      name: 'Placer',
      logo: '/partners/placer.png',
      alt: 'Placer.ai'
    },
    {
      name: 'Lightcast',
      logo: '/partners/lightcast.png',
      alt: 'Lightcast'
    }
  ];

  return (
    <section className="py-16 bg-gray-100 border-y border-gray-200">
      <div className="container mx-auto px-6">
        <div className="text-center mb-10">
          <h3 className="text-2xl font-bold text-gray-800 mb-2">
            Powered by Industry-Leading Technologies
          </h3>
          <p className="text-gray-600">
            We leverage the best tools to deliver exceptional GIS solutions
          </p>
        </div>
        
        <div className="flex flex-wrap items-center justify-center gap-8 md:gap-12 lg:gap-16">
          {partners.map((partner, index) => (
            <div
              key={index}
              className="group relative flex items-center justify-center h-20 w-32 md:w-40 lg:w-48 transition-all duration-300 hover:scale-110"
            >
              <img
                src={partner.logo}
                alt={partner.alt}
                className="max-h-full max-w-full object-contain filter grayscale opacity-60 group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-300"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Partners;
